module.exports = __webpack_public_path__ + "materialdesignicons-webfont.4fed03f1e0fb21693813.woff";


//////////////////
// WEBPACK FOOTER
// C:/WORK/ZENN/mcr-contabilidade-fileshare/Application/ApplicationUI/src/assets/scss/icons/material-design-iconic-font/fonts/materialdesignicons-webfont.woff?v=1.8.36
// module id = ../../../../../src/assets/scss/icons/material-design-iconic-font/fonts/materialdesignicons-webfont.woff?v=1.8.36
// module chunks = styles